<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-2 gap-x-4">
      <!-- ref number-->
      <div class="flex items-center">
        <svg-icon name="ref" class="me-2 icon-6xl contact-us_ref-logo" />
        <div class="whitespace-pre-line flex-shrink-0">
          {{ catalogNumber }}
        </div>
      </div>

      <!-- md logo -->
      <div class="flex">
        <svg-icon name="md" class="icon-6xl contact-us_md-logo" />
      </div>

      <!-- ce logo -->
      <div class="flex items-start">
        <div class="flex items-end">
          <svg-icon name="ce_logo" class="me-2 icon-6xl contact-us_ce-logo" />
          <div class="whitespace-pre-line flex-shrink-0">
            {{ notifiedBodyNumber }}
          </div>
        </div>
      </div>

      <!-- swiss made software logo -->
      <div class="flex items-center">
        <svg-icon
          name="swissMadeSoftware"
          class="icon-7xl contact-us_swiss-made-software-logo"
        />
      </div>
    </div>

    <div class="flex pt-4">
      <!-- udi -->
      <div
        class="inline-block px-2 py-1 border border-blue-800 rounded text-blue-800"
      >
        <span class="font-bold text-lg">UDI</span>
        <span class="contact-us_udi">{{ udiNumber }}{{ version }}</span>
      </div>
    </div>
    <div class="flex items-center pt-4">
      <svg-icon name="manufacture-date" class="me-2" />
      <div class="whitespace-pre-line flex-shrink-0 contact-us_manufacturer">
        {{ productIsoDate }}
      </div>
    </div>
    <div class="pt-4">
      <toggle
        triggerClassHeader="flex items-center w-full text-h3"
        triggerClassContent="flex flex-col items-start pt-2"
      >
        <template #header>
          <p class="me-4">{{ $t("Legal.softwareVersion") }} {{ version }}</p>
        </template>
        <template #default>
          <loading-layout v-if="isLoading" />
          <div v-else>
            <p class="sm-2">WebApp {{ buildVersion }}</p>
            <p class="sm-2">User {{ usermsVersion }}</p>
            <p class="sm-2">Activity {{ activitymsVersion }}</p>
            <p class="sm-2">License {{ licensemsVersion }}</p>
            <p class="sm-2">Notification {{ notificationmsVersion }}</p>
            <p class="sm-2">Audit {{ auditmsVersion }}</p>
            <p class="sm-2">EPRO {{ epromsversion }}</p>
            <p class="sm-2">EPRO WebApp {{ eproWebappversion }}</p>
          </div>
        </template>
      </toggle>
    </div>
  </div>
</template>

<script>
import { formatToyyyyMMdd } from "@/utils/date";
import {
  activityApi,
  userApi,
  licenseApi,
  notificationApi,
  auditApi,
  eproApi,
  eproWebApi,
} from "@/services/api";
import loadConfigData from "@/services/configJson";
import Toggle from "@/components/ui/Toggle.vue";

export default {
  components: {
    Toggle,
  },
  mounted() {
    this.loadSoftwareInfo();
  },
  data() {
    return {
      isLoading: false,
      catalogNumber: "CMP-01",
      udiNumber: " (01)03760272650095(10) ",
      notifiedBodyNumber: "0459",
      buildVersion: "",
      version: "",
      productDate: "",
      activitymsVersion: "",
      usermsVersion: "",
      licensemsVersion: "",
      notificationmsVersion: "",
      auditmsVersion: "",
      epromsversion: "",
      eproWebappversion: "",
    };
  },
  computed: {
    productIsoDate() {
      if (this.productDate) {
        const date = new Date(this.productDate);
        return formatToyyyyMMdd(date);
      }
      return "";
    },
  },
  methods: {
    loadSoftwareInfo() {
      this.isLoading = true;
      const versionUrl = "metadata/assembly/";

      const dataPromises = [
        loadConfigData().then((configData) => {
          this.buildVersion = configData.BuildVersion;
          this.version = configData.ProductVersion;
          this.productDate = configData.ProductDate;
        }),
        activityApi.get(versionUrl).then((response) => {
          this.activitymsVersion = response.data.version;
        }),
        userApi.get(versionUrl).then((response) => {
          this.usermsVersion = response.data.version;
        }),
        licenseApi.get(versionUrl).then((response) => {
          this.licensemsVersion = response.data.version;
        }),
        notificationApi.get(versionUrl).then((response) => {
          this.notificationmsVersion = response.data.version;
        }),
        auditApi.get(versionUrl).then((response) => {
          this.auditmsVersion = response.data.version;
        }),
        eproApi.get("/actuator/info").then((response) => {
          this.epromsversion = response.data.version;
        }),
        eproWebApi.get("/version.json").then((response) => {
          this.eproWebappversion = response.data.version;
        }),
      ];

      Promise.all(dataPromises).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>
